module.exports = __webpack_public_path__ + "static/media/Icon-04@2x.8a2d8c4f.png";